import { jsx as _jsx } from "react/jsx-runtime";
import { LineContainer } from "./propertyLines/propertyLine";
import { Button } from "../primitives/button";
/**
 * Wraps a button with a label in a line container
 * @param props Button props plus a label
 * @returns A button inside a line
 */
export const ButtonLine = (props) => {
    ButtonLine.displayName = "ButtonLine";
    const { uniqueId, ...buttonProps } = props;
    return (_jsx(LineContainer, { uniqueId: uniqueId ?? props.label, children: _jsx(Button, { ...buttonProps }) }));
};
//# sourceMappingURL=buttonLine.js.map